export default "__VITE_ASSET__BIIjtlTP__"